import { Fragment } from 'react';
import { Link } from 'react-router-dom';

import { cn } from '../lib/utils';

import type { Props } from './types';

/**
 * Where you are, read outermost first: `People / Profile`. Every crumb but the last links back up
 * to its level, and the last names the page you are on.
 *
 * Crumbs truncate rather than wrap, so the trail holds a single line in a narrow bar.
 */
function Breadcrumbs({ items, className }: Props) {
  return (
    <nav aria-label="Breadcrumb" className={cn('min-w-0', className)}>
      <ol className="flex min-w-0 items-center gap-x-1.5 text-sm">
        {items.map((item, index) => {
          const current = index === items.length - 1;

          return (
            <Fragment key={`${index}-${item.label}`}>
              {index > 0 && (
                <li aria-hidden="true" className="shrink-0 text-gray-600">
                  /
                </li>
              )}
              <li className="min-w-0 truncate">
                {item.to && !current ? (
                  <Link
                    to={item.to}
                    className="font-medium text-gray-700 hover:text-gray-900 hover:underline dark:hover:text-gray-100">
                    {item.label}
                  </Link>
                ) : (
                  <span
                    aria-current={current ? 'page' : undefined}
                    className="font-semibold text-gray-900 dark:text-gray-100">
                    {item.label}
                  </span>
                )}
              </li>
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}

export { Breadcrumbs };
